export const SWATCHES: string[] = [
  // Row 1 – lightest tints
  '#FFB3C1',
  '#FFB3D9',
  '#FFB3F5',
  '#E0B3FF',
  '#C4B3FF',
  '#B3C4FF',
  '#B3DCFF',
  '#B3F0FF',
  '#B3FFF0',
  '#B3FFD9',
  '#C4FFB3',
  '#DCFFB3',
  '#F0FFB3',
  '#FFFBB3',
  '#FFE8B3',
  '#FFD4B3',
  '#FFC0B3',
  '#E8E8E8',
  '#D4D4D4',
  '#C0C0C0',

  // Row 2
  '#FF80A0',
  '#FF80C0',
  '#FF80EE',
  '#CC80FF',
  '#9E80FF',
  '#809EFF',
  '#80CCFF',
  '#80EEFF',
  '#80FFEE',
  '#80FFCC',
  '#9EFF80',
  '#CCFF80',
  '#EEFF80',
  '#FFF880',
  '#FFDC80',
  '#FFC080',
  '#FFA080',
  '#D8D8D8',
  '#BEBEBE',
  '#A8A8A8',

  // Row 3
  '#FF4D7A',
  '#FF4DA8',
  '#FF4DE8',
  '#B84DFF',
  '#784DFF',
  '#4D78FF',
  '#4DB8FF',
  '#4DE8FF',
  '#4DFFE8',
  '#4DFFB8',
  '#78FF4D',
  '#B8FF4D',
  '#E8FF4D',
  '#FFF04D',
  '#FFD04D',
  '#FFAA4D',
  '#FF804D',
  '#C8C8C8',
  '#ABABAB',
  '#909090',

  // Row 4 – vivid mids
  '#FF1A5C',
  '#FF1A90',
  '#FF1AE2',
  '#A31AFF',
  '#521AFF',
  '#1A52FF',
  '#1AA3FF',
  '#1AE2FF',
  '#1AFFE2',
  '#1AFFA3',
  '#52FF1A',
  '#A3FF1A',
  '#E2FF1A',
  '#FFE81A',
  '#FFC41A',
  '#FF941A',
  '#FF601A',
  '#B8B8B8',
  '#969696',
  '#787878',

  // Row 5
  '#E0005A',
  '#E00088',
  '#E000DC',
  '#9400E0',
  '#4400E0',
  '#0044E0',
  '#0094E0',
  '#00DCE0',
  '#00E0DC',
  '#00E094',
  '#44E000',
  '#94E000',
  '#DCE000',
  '#E0DC00',
  '#E0B800',
  '#E08400',
  '#E04400',
  '#A8A8A8',
  '#888888',
  '#686868',

  // Row 6
  '#BC004C',
  '#BC0074',
  '#BC00BC',
  '#7C00BC',
  '#3800BC',
  '#003CBC',
  '#007CBC',
  '#00BCBC',
  '#00BC7C',
  '#00BC3C',
  '#38BC00',
  '#7CBC00',
  '#BCBC00',
  '#BCB800',
  '#BC9400',
  '#BC6800',
  '#BC3400',
  '#989898',
  '#787878',
  '#585858',

  // Row 7 – deeper
  '#960040',
  '#960060',
  '#960096',
  '#640096',
  '#2C0096',
  '#003096',
  '#006496',
  '#009696',
  '#006464',
  '#009640',
  '#2C9600',
  '#649600',
  '#969600',
  '#968C00',
  '#967000',
  '#965000',
  '#962800',
  '#888888',
  '#666666',
  '#484848',

  // Row 8
  '#6E0030',
  '#6E0048',
  '#6E006E',
  '#4A006E',
  '#20006E',
  '#00206E',
  '#004A6E',
  '#006E6E',
  '#004A4A',
  '#006E30',
  '#206E00',
  '#4A6E00',
  '#6E6E00',
  '#6E6400',
  '#6E4A00',
  '#6E3400',
  '#6E1800',
  '#707070',
  '#505050',
  '#363636',

  // Row 9 – darkest
  '#440020',
  '#440030',
  '#440044',
  '#2C0044',
  '#100044',
  '#001044',
  '#002C44',
  '#004444',
  '#002C2C',
  '#00441C',
  '#104400',
  '#2C4400',
  '#444400',
  '#443C00',
  '#442800',
  '#441800',
  '#440800',
  '#505050',
  '#383838',
  '#1A1A1A',
];
